import articelApi from "@/service/modules/articelApi";
import { message } from "antd";

const getArticle = async (articleName: string) => {
  try {
    const response = await articelApi.getArticleContent(articleName);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching article content:", error);
    message.error(error?.message || "Failed to load article content");
    throw error;
  }
};

const base64Decode = (base64: string) => {
  if (typeof window === "undefined") {
    return Buffer.from(base64, "base64").toString("utf-8");
  }

  const binary = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(binary);
};

export { getArticle, base64Decode };
